(() => {
  const init = () => {
    const header = document.querySelector('.t7-page--index .t4-header');
    if (!header || header.dataset.t978Ready) return;

    header.dataset.t978Ready = 'true';
    const hero = document.querySelector('.t7-page--index [data-t94-hero]');
    const depthFilm = document.querySelector('.t7-page--index [data-t6-depth]');
    const mobileQuery = window.matchMedia('(max-width: 760px)');
    const readScrollY = () => Math.max(
      window.scrollY || 0,
      document.documentElement.scrollTop || 0,
      document.body.scrollTop || 0,
      0
    );
    const layoutTop = element => {
      let top = 0;
      let node = element;
      while (node) {
        top += node.offsetTop || 0;
        node = node.offsetParent;
      }
      return top;
    };
    let depthTop = depthFilm ? layoutTop(depthFilm) : Infinity;
    let depthBottom = depthFilm ? depthTop + depthFilm.offsetHeight : Infinity;
    let lastScrollY = readScrollY();
    let direction = 0;
    let directionDistance = 0;
    let ticking = false;

    const syncContrast = () => {
      const mode = header.dataset.heroContrast || 'automatic';
      const activeTone = hero?.dataset.activeTone ||
        hero?.querySelector('[data-t94-slide].is-active')?.dataset.slideTone ||
        'dark';
      const useLightArtwork = mode === 'light' || (mode === 'automatic' && activeTone === 'light');
      header.classList.toggle('is-over-dark', useLightArtwork);
    };

    const render = () => {
      const currentScrollY = readScrollY();
      const isScrolled = currentScrollY > 1;
      const behavior = mobileQuery.matches
        ? (header.dataset.mobileScroll || 'hide_on_down')
        : (header.dataset.desktopScroll || 'always_visible');
      const menuIsOpen = header.classList.contains('is-menu-open') || Boolean(document.querySelector('[data-t4-menu-panel][open]'));
      const depthIsActive = currentScrollY >= depthTop && currentScrollY < depthBottom - 1;
      const delta = currentScrollY - lastScrollY;
      const nextDirection = Math.sign(delta);

      if (nextDirection && nextDirection !== direction) {
        direction = nextDirection;
        directionDistance = delta;
      } else {
        directionDistance += delta;
      }
      lastScrollY = currentScrollY;

      header.classList.toggle('is-scrolled', isScrolled);
      header.classList.toggle('is-depth-active', depthIsActive);
      syncContrast();

      if (menuIsOpen) {
        header.classList.remove('is-hidden');
      } else if (depthIsActive) {
        header.classList.add('is-hidden');
      } else if (!isScrolled || behavior === 'always_visible') {
        header.classList.remove('is-hidden');
      } else if (behavior === 'always_hidden') {
        header.classList.add('is-hidden');
      } else if (directionDistance > 8) {
        header.classList.add('is-hidden');
        directionDistance = 0;
      } else if (directionDistance < -4) {
        header.classList.remove('is-hidden');
        directionDistance = 0;
      }
      ticking = false;
    };

    const schedule = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(render);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', () => {
      depthTop = depthFilm ? layoutTop(depthFilm) : Infinity;
      depthBottom = depthFilm ? depthTop + depthFilm.offsetHeight : Infinity;
      schedule();
    }, { passive: true });

    header.addEventListener('toggle', schedule, true);
    mobileQuery.addEventListener?.('change', schedule);
    if (hero) {
      new MutationObserver(schedule).observe(hero, {
        attributes: true,
        attributeFilter: ['data-active-tone']
      });
    }

    render();
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
